import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { AppDialogHelper } from 'general/components/AppDialog';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown, { KTBSDropdownDirections } from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
    KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import EmptyView from 'general/components/Others/EmptyView';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import DropdownTableConfigColumn from 'general/components/DropdownTableConfigColumn';
import AppConstants from 'general/constants/AppConstants';
import MenuActionDropdown from 'general/components/Others/MenuActionDropdown';
import AppRoute from 'general/constants/AppRoute';
import AgencyHelper from 'features/Agency/agencyHelper';
import Utils from 'general/utils/Utils';
import useAppConfig from 'hooks/useAppConfig';

RemainingAgenciesView.propTypes = {};

const defaultColumnIds = ['AGENCY_CODE', 'AGENCY_NAME', 'ROLE', 'AGENCY_TYPE', 'PHONE', 'EMAIL', 'TAXCODE/CCCD', 'STATUS'];
function RemainingAgenciesView(props) {
    // ---- params ----
    const router = useRouter();
    const { t } = useTranslation();
    const { agencyId, remainingAgenciesList, remainingAgenciesTotal, onFilterChanged, filter, handleGetRemainingAgenciesList } = props;
    const app = useSelector((state) => state.app);
    const { user } = useSelector((state) => state.auth);
    const [operatorList, setOperatorList] = useState([]);
    const adminRole = user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    const commissionRateSale = useAppConfig()?.commissionRateSale;
    const commissionRateGroup = useAppConfig()?.commissionRateGroup;
    const commissionRateLandlord = useAppConfig()?.commissionRateLandlord;
    const operatorId = useMemo(() => {
        return app?.appConfig?.operators?.[0]?.operatorId ?? null;
    }, [app]);

    const fullColumns = useMemo(() => {
        return [
            {
                id: 'AGENCY_CODE',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('Mã đối tác')}</span>,
                selector: (row) => row?.agencyCode ?? row.agencyId,
                minWidth: '140px',
                style: tableStyle.columns.normal,
                sortable: true,
            },
            {
                id: 'AGENCY_NAME',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('Tên đối tác')}</span>,
                selector: (row) => row.name ?? 'N/A',
                minWidth: '230px',
                style: tableStyle.columns.link,
                sortable: true,
            },
            {
                id: 'ROLE',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('Vai trò')}</span>,
                selector: (row) => t(`agencyRoleDropdownTitle_${row?.primaryRole}`) ?? 'N/A',
                minWidth: '230px',
                style: tableStyle.columns.normal,
                sortable: true,
            },
            {
                id: 'AGENCY_TYPE',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('Loại đối tác')}</span>,
                selector: (row) => row.type ? t(`accountType_${row.type}`) : 'N/A',
                style: tableStyle.columns.normal,
                minWidth: '110px',
                sortable: true,
            },
            {
                id: 'PHONE',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('phone')}
                    </span>
                ),
                selector: (row) => row.phone ?? '',
                style: tableStyle.columns.normal,
                sortable: false,
                width: '140px',
            },
            {
                id: 'EMAIL',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('email')}
                    </span>
                ),
                selector: (row) => {
                    return (
                        <KTTooltip offset={[0, 0]} text={row?.email ?? ''}>
                            <span>{row?.email ?? ''}</span>
                        </KTTooltip>
                    );
                },
                style: tableStyle.columns.normal,
                minWidth: '250px',
            },
            {
                id: 'TAXCODE/CCCD',
                name: (
                    <span
                        className="letter-spacing-unset"
                        style={{
                            fontSize: 12,
                            color: AppColors.gray[900],
                        }}
                    >
                        {t('MST/CCCD')}
                    </span>
                ),
                selector: (row) =>
                    row.type === AppConstants.accountType.individual
                        ? row.idCardNumber?.length > 0
                            ? row.idCardNumber
                            : row.taxCode?.length > 0
                                ? row.taxCode
                                : ''
                        : row.taxCode?.length > 0
                            ? row.taxCode
                            : '',
                style: tableStyle.columns.normal,
                sortable: false,
                width: '150px',
            },
            {
                id: 'STATUS',
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('status')}</span>,
                minWidth: '150px',
                selector: (row) => (
                    <KTLabel
                        text={t(`agencyStatus_${row.status}`)}
                        isInline={true}
                        size={KTLabelSize.medium}
                        additionalClassName={`label-light-${DealerHelper.getAgencyStatusColor(row.status)}`}
                    />
                ),
                sortable: false,
            },
            {
                name: <span style={{ fontSize: 12, color: AppColors.gray[900] }} className="letter-spacing-unset">{t('actions')}</span>,
                width: '130px',
                style: {
                    position: 'sticky',
                    right: 0,
                    backgroundColor: '#fff',
                    borderLeft: '1px solid #ebedfe',
                },
                wrap: true,
                cell: (row) => (
                    <MenuActionDropdown
                        menuAction={[
                            {
                                iconElement: <i className="fa-regular fa-eye" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('Xem chi tiết'),
                                click: () => {
                                    AgencyHelper.Navigation.navigateToAgencyDetail(null, row);
                                },
                                show: true,
                            },
                            {
                                iconElement: <i className="fa-regular fa-bolt" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('Kích hoạt tài khoản'),
                                click: () => {
                                    DealerHelper.handleAcceptAgency(row, handleGetRemainingAgenciesList);
                                },
                                show: row?.status === 'REGISTERED'
                                    && (adminRole ||
                                        DealerHelper.checkHasEditPermission(
                                            row,
                                            row?.parentAgency,
                                            user?.agency
                                        )),
                            },
                            {
                                iconElement: <i className="fa-regular fa-pen-to-square" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('edit'),
                                click: () => {
                                    if (row?.primaryRole === 'GROUP') {
                                        Utils.openInNewTab(`${AppRoute.groupList}/${row?.agencyId}/edit`);
                                    } else if (row?.primaryRole === 'INVESTOR') {
                                        Utils.openInNewTab(`${AppRoute.investorList}/${row?.agencyId}/edit`);
                                    } else if (row?.primaryRole === 'LANDLORD') {
                                        Utils.openInNewTab(`${AppRoute.landlordList}/${row?.agencyId}/edit`);
                                    }
                                },
                                show: (!row?.numberOfSignedContracts
                                    && DealerHelper.checkHasEditPermission(
                                        row,
                                        row?.parentAgency,
                                        user?.agency
                                    )) || adminRole,
                            },
                            {
                                iconElement: <i className="fa-regular fa-plus-circle" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('addOrder'),
                                click: () => {
                                    if (row?.primaryRole === 'GROUP') {
                                        Utils.openInNewTab(`${AppRoute.groupList}/add-order?group=${row?.agencyId}`);
                                    } else if (row?.primaryRole === 'INVESTOR') {
                                        Utils.openInNewTab(`${AppRoute.investorList}/add-order?investor=${row?.agencyId}`);
                                    } else if (row?.primaryRole === 'LANDLORD') {
                                        Utils.openInNewTab(`${AppRoute.landlordList}/add-order?landlord=${row?.agencyId}`);
                                    }
                                },
                                show: row?.status !== 'REGISTERED'
                                    && (adminRole || DealerHelper.checkHasEditPermission(
                                        row,
                                        row?.parentAgency,
                                        user?.agency
                                    ))
                                    && user?.agency?.primaryRole === 'SALE',
                            },
                            {
                                iconElement: <i className="far fa-square" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('Ngừng hoạt động'),
                                click: () => {
                                    DealerHelper.handleStopAgency(row, handleGetRemainingAgenciesList);
                                },
                                show: row?.status === 'NORMAL'
                                    && (adminRole || DealerHelper.checkHasEditPermission(
                                        row,
                                        row?.parentAgency,
                                        user?.agency
                                    )),
                            },
                            {
                                iconElement: <i className="far fa-play" style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('Khôi phục hoạt động'),
                                click: () => {
                                    DealerHelper.handleActiveAgency(row, handleGetRemainingAgenciesList);
                                },
                                show: row?.status === 'SUSPENDED'
                                    && (adminRole || DealerHelper.checkHasEditPermission(
                                        row,
                                        row?.parentAgency,
                                        user?.agency
                                    )),
                            },
                            {
                                iconElement: (
                                    <i
                                        className="fa-regular fa-file-contract"
                                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                    ></i>
                                ),
                                text: 'Tạo hợp đồng CTV',
                                click: () => {
                                    // AgencyHelper.UI.showDialogConfirmCreateContractWithSale(row, () => {});
                                    AgencyHelper.UI.showDialogConfirmCreateContractWithAgency(
                                        row,
                                        () => { },
                                        undefined,
                                        async () => {
                                            const hasSaleCommission =
                                                row && row.commissions
                                                    ? await row.commissions.some(
                                                        (commission) => commission?.role === 'SALE'
                                                    )
                                                    : false;

                                            if (!hasSaleCommission) {
                                                await handleCreateSaleCommission(row);
                                            }
                                        }
                                    );
                                },
                                show:
                                    row?.status !== 'REGISTERED'
                                    && adminRole
                                    && row?.primaryRole !== 'LANDLORD',
                            },
                            {
                                iconElement: <i className={`fa-regular fa-lock`} style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t('Đặt lại mật khẩu'),
                                click: () => {
                                    DealerHelper.showDialogChangePassword(row, handleGetRemainingAgenciesList)
                                },
                                show: adminRole,
                            },
                            {
                                iconElement: <i className={`fa-regular fa-trash-can`} style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}></i>,
                                text: t(`Xóa ${row?.primaryRole === 'LANDLORD' ? 'chủ mặt bằng' : 'nhà đầu tư'}`),
                                click: () => {
                                    DealerHelper.handleDeleteAgency(row, handleGetRemainingAgenciesList);
                                },
                                show: !row?.numberOfSignedContracts
                                    && (adminRole || DealerHelper.checkHasEditPermission(
                                        row,
                                        row?.parentAgency,
                                        user?.agency
                                    )),
                            },
                        ]}
                    />
                ),
                sortable: false,
            },
        ];
    }, [t, operatorList]);

    const prefKey = useMemo(() => {
        const userId = user.userId;
        const pathName = `${router.pathname}${router.location.hash}`;
        const key = `${userId}_${pathName}`;
        return key;
    }, [user, router]);
    const [fullColumnIds, setFullColumnIds] = useState(fullColumns?.map((row) => row?.id).filter(Boolean));
    const {
        columnIds,
        columns,
        onChangeCheckboxValue,
        resetDefaultTableColumn,
        saveChanges,
        onSelectAll,
        onUnSelectAll,
        fullColumnsIdSorted
    } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

    // ---- methods ----

    const classifyOperators = (operators) => {
        setOperatorList(
            operators?.map((operator) => ({ operatorId: operator.operatorId, name: operator.name }))
        );
    };

    useEffect(() => {
        if (app.appConfig) {
            classifyOperators(app.appConfig.operators ?? []);
        }
    }, [app.appConfig]);

    const handleFilterChanged = (filter) => {
        if (onFilterChanged) {
            onFilterChanged(filter);
        }
    };

    const handleCreateSaleCommission = async (row) => {
        await DealerHelper.callApiCreateAgencyCommission(
            Utils.transformEmptyStrings({
                operatorId: operatorId,
                agencyId: row?.agencyId,
                role: 'SALE',
                energyCommissionMode: AppConstants.energyCommissionMode.fixedPerKwh,
                energyCommissionValue: 0,
                energyCommissionDuration: null,
                serviceCommission: 0,
                saleCommission: [
                    {
                        revenue: 0,
                        discount: Number(commissionRateSale),
                    },
                ],
                packageCommission: [
                    {
                        revenue: 0,
                        discount: Number(commissionRateGroup),
                    },
                ],
                landlordCommission: JSON.parse(commissionRateLandlord),
            })
        );
        handleGetRemainingAgenciesList();
    };

    const agencyRoleOptionList = [
        {
            name: 'Tất cả',
            value: 'INVESTOR, GROUP, LANDLORD, COINVESTOR'
        },
        ...DealerHelper.filterAgencyRoleOptions()
    ]


    return (
        <div>
            {/* header */}
            <div className="w-100 d-flex flex-row align-items-end flex-wrap">
                {/* Tìm kiếm */}
                <div className="w-xl-22 w-md-50 px-0 pr-sm-4 py-2">
                    <label htmlFor="search-bar" style={{ color: AppColors.gray[800] }} className="mb-0 mr-2 font-weight-boldest">
                        {t('search')}
                    </label>
                    <KTFormSearch
                        name="search-bar"
                        placeholder={t('Theo mã đối tác, tên đối tác, số điện thoại, email...')}
                        value={filter.q}
                        onSubmit={(text) => {
                            handleFilterChanged({
                                q: text,
                            });
                        }}
                    />
                </div>

                {/* Lọc theo vai trò */}
                <div className="w-xl-22 w-md-50 px-0 pr-lg-4 py-2">
                    <label htmlFor="status" style={{ color: AppColors.gray[800] }} className="mb-0 mr-2 font-weight-boldest">
                        {t('Vai trò')}
                    </label>
                    <KTBSDropdown
                        toggleElement={
                            <button
                                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                type="button"
                            >
                                {agencyRoleOptionList?.find(role => role.value == filter.role)?.name}
                            </button>
                        }
                        selectedValue={filter.role}
                        dropdownMenuItems={agencyRoleOptionList}
                        dropdownMenuClassName="overflow-auto w-100"
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        onChange={(value) => {
                            handleFilterChanged({
                                role: value,
                            });
                        }}
                        isDropdownForm={true}
                        direction={KTBSDropdownDirections.up}
                    />
                </div>

                {/* Lọc loại đối tác */}
                <div className="w-xl-22 w-md-50 px-0 pr-sm-4 py-2">
                    <label htmlFor="status" style={{ color: AppColors.gray[800] }} className="mb-0 mr-2 font-weight-boldest">
                        {t('Loại đối tác')}
                    </label>
                    <KTBSDropdown
                        toggleElement={
                            <button
                                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                type="button"
                            >
                                {filter.type ? t(`accountType_${filter.type}`) : 'Tất cả'}
                            </button>
                        }
                        selectedValue={filter.type}
                        dropdownMenuItems={DealerHelper.filterAgencyTypeOptions()}
                        dropdownMenuClassName="overflow-auto w-100"
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        onChange={(value) => {
                            handleFilterChanged({
                                type: value,
                            });
                        }}
                        isDropdownForm={true}
                        direction={KTBSDropdownDirections.up}
                    />
                </div>

                {/* Lọc theo trạng thái */}
                <div className="w-xl-22 w-md-50 px-0 pr-lg-4 py-2">
                    <label htmlFor="status" style={{ color: AppColors.gray[800] }} className="mb-0 mr-2 font-weight-boldest">
                        {t('filterByStatus')}
                    </label>
                    <KTBSDropdown
                        toggleElement={
                            <button
                                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                type="button"
                            >
                                {!_.isEmpty(filter.status)
                                    ? t(`agencyStatus_${filter.status}`)
                                    : t('all')}
                            </button>
                        }
                        selectedValue={filter.status}
                        dropdownMenuItems={DealerHelper.filterStatusOptions()}
                        dropdownMenuClassName="overflow-auto w-100"
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        onChange={(value) => {
                            handleFilterChanged({
                                status: value,
                            });
                        }}
                        isDropdownForm={true}
                        direction={KTBSDropdownDirections.up}
                    />
                </div>

                {/* cau hinh cot */}
                <div className="pl-0 py-2">
                    <DropdownTableConfigColumn
                        columnIds={columnIds}
                        fullColumns={fullColumns}
                        fullColumnIds={fullColumnsIdSorted}
                        onChangeCheckboxValue={onChangeCheckboxValue}
                        saveChanges={saveChanges}
                        resetDefaultTableColumn={() => {
                            setFullColumnIds(defaultColumnIds);
                            resetDefaultTableColumn();
                        }}
                        onChangeFullColumnIds={(ids) => {
                            setFullColumnIds(ids);
                            const key = prefKey + '_FULL_COLUMN_IDS';
                            localStorage.setItem(key, ids.join('|'));
                        }}
                        onSelectAll={onSelectAll}
                        onUnSelectAll={onUnSelectAll}
                        direction={KTBSDropdownDirections.up}
                    />
                </div>
            </div>

            {/* Body */}
            <div className="mt-4">
                <KTTable
                    columns={columns}
                    items={remainingAgenciesList}
                    selectableRows={false}
                    striped={false}
                    compactGrid={false}
                    onClickedRow={() => { }}
                    onSelectedRowsChanged={(rows) => { }}
                    onDoubleClickedRow={(rows) => { }}
                    noDataComponent={
                        <EmptyView
                            icon={imgEmptyNoData}
                            title="Không có dữ liệu để hiển thị"
                            text={
                                <div className="text-center">
                                    <span>
                                        Hiện không có dữ liệu để hiển thị. Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.
                                    </span>
                                </div>
                            }
                        />
                    }
                />
            </div>

            {/* Phân trang */}
            {!_.isEmpty(remainingAgenciesList) && (
                <div className="mt-4">
                    <KTPagination
                        currentPage={filter.page + 1}
                        rowCount={remainingAgenciesTotal}
                        rowsPerPage={filter.limit}
                        currentItemInPageCount={remainingAgenciesList.length}
                        onChangePage={(newPage) => {
                            const iNewPage = parseInt(newPage);
                            handleFilterChanged({
                                page: iNewPage - 1,
                            });
                        }}
                        onChangeRowsPerPage={(newRowsPerPage) => {
                            const iNewRowsPerPage = parseInt(newRowsPerPage);
                            handleFilterChanged({
                                limit: iNewRowsPerPage,
                                page: 0,
                            });
                        }}
                        loading={false}
                        color={KTPaginationColor.success}
                        appendText="đối tác"
                    />
                </div>
            )}
        </div>
    );
}

export default RemainingAgenciesView;
